import React from "react";
import FilterSelect from "../../FilterSelect";
import { formatOptions } from "../util";
import SingleSelect from "@home/components/SingleSelect";
import { TRenderComMap } from "../_type";
// import RevenueRange from "@intelligence/components/RevenueRange";
import RangeSelect from "@/pages/benchmark/components/RangeSelector";
import CascadeFilterComponent from "@/pages/dashboard/components/CascadeFilterComponent";
import { HIDE_ALL_KEYS, SHOW_NONE_PLACEHOLDER_KEYS } from "./_config";

// 自定义下拉筛选器
const renderCustom = (props: any) => {
  const { key, value, options, onChange, name, getLocalText, allInfo, locale, radioOptions, renderKey, defaultValue, valueKey = 'code',
    cnKey = 'name_ch', enKey = 'name_en', iconKey = 'icon', view_type = 'multiple', className, isPopupContainer = true,
    // 级联筛选器特有属性
    parentKey,
    childKey,
    lftName,
    rtName,
    ...restProps } = props || {};
  const rawRadio = HIDE_ALL_KEYS?.includes(key) ? [] : (radioOptions);
  const resolvedRadioOptions = rawRadio !== undefined && rawRadio !== null
    ? rawRadio
    : [{
      value: '255',
      text: getLocalText('selector_multiple_component_custom_filter_all_describe', {}, false),
      info: allInfo || getLocalText('selector_multiple_component_common_all_info', { name }, false)
    }];
  const filterProps = {
    key,
    className: `search-item ${renderKey} ${className}`,
    overlayClassName: `${isPopupContainer ? 'dbd-filter-select-dropdown' : ''}`,
    value,
    locale,
    matchButtonWidth: true,
    clickClose: false,
    closeOnScroll: false,
    positionFixed: false,
    ...(isPopupContainer ? { popupContainer: () => document.querySelector(`.${renderKey}`) } : {}),
    radioOptions: resolvedRadioOptions,
    options: formatOptions({
      options,
      locale,
      valueKey,
      cnKey,
      enKey,
      iconKey
    }),
    name: name || getLocalText('selector_multiple_component_system_label', {}, false),
    showNonePlaceholder: SHOW_NONE_PLACEHOLDER_KEYS.includes(key) || false,
    onChange: (value: any) => {
      onChange(key, value);
    },
    ...restProps
  };

  // renderCustom是一个方法，所以不能使用hooks处理
  const singleOptions = formatOptions({
    options,
    locale,
    valueKey,
    cnKey,
    enKey,
    iconKey,
    deleteAllValue: false
  });

  const singleVal = Array.isArray(value) ? value?.[0] : value;
  const singleDefaultVal = Array.isArray(defaultValue) ? defaultValue?.[0] : defaultValue;

  //  单选是benchmark用到，多选是经分这边最开始 需求约定经分自定义暂时只支持多选下拉
  const renderComMap: TRenderComMap = {
    single: <SingleSelect {...filterProps} options={singleOptions} value={singleVal} defaultValue={singleDefaultVal} />,
    multiple: <FilterSelect {...filterProps} />,
    range: <RangeSelect
      {...restProps}
      name={name}
      className={`search-item ${renderKey} ${className}`}
      popupContainer={() => document.querySelector(`.${renderKey}`)}
      value={value}
      locale={locale}
      onChange={(value: any) => {
        onChange?.(key, value);
      }}
      clickClose={false}
      closeOnScroll={false}
      positionFixed={false}
    />,
    cascade: <CascadeFilterComponent
      key={key}
      filterKey={key}
      value={value}
      options={options}
      onChange={onChange}
      locale={locale}
      name={name}
      allInfo={allInfo}
      lftName={lftName}
      rtName={rtName}
      parentKey={parentKey}
      childKey={childKey}
      radioOptions={resolvedRadioOptions}
      renderKey={renderKey}
      className={className}
      getLocalText={getLocalText}
      {...restProps}
    />,
    default: <FilterSelect {...filterProps} />
  };

  return <>
    {
      renderComMap?.[view_type as keyof typeof renderComMap] || renderComMap.default
    }
  </>;
};

export default renderCustom;